import { Box, Typography, IconButton, Link } from '@mui/material'
import { CheckCircle, Delete } from '@mui/icons-material'
import { GetDownloadUrl } from '../../../../../services/FileService'
import { styles } from './SurveyFileDisplay.styles'

interface Props {
  fileName: string | null | undefined
  fileKey: string | null | undefined
  onDelete: () => void
}

export function SurveyFileDisplay ({ fileName, fileKey, onDelete }: Props): JSX.Element | null {
  if (fileName == null || fileName === '') {
    return null
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.contentWrapper}>
        <CheckCircle color='success' sx={styles.icon} />
        <Link
          href={fileKey != null ? GetDownloadUrl(fileKey) : '#'}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={styles.link}
        >
          <Typography variant="body1" noWrap>{fileName}</Typography>
        </Link>
      </Box>
      <IconButton onClick={onDelete} aria-label="delete">
        <Delete />
      </IconButton>
    </Box>
  )
}
